import { generateRowsData } from "./generateAssetRowsData";
import { columns } from "./assetColumns";

export const generateAssetTableData = (rawData) => {
    var rowsData = generateRowsData(rawData)
    return {rows: rowsData, columns: columns }
}